var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sections),function(section){return _c('div',{staticClass:"section"},_vm._l((section),function(char){return _c('div',{key:char,staticClass:"character"},[_c('Sample',{attrs:{"displayWidth":_vm.width,"displayHeight":_vm.width,"model":_vm.model,"modelData":char,"sample":_vm.sample,"visible":_vm.visible,"on:select":"fire('select', event)"}})],1)}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a3ed29c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Alphabet.vue
// module id = 331
// module chunks = 1